export const VARIANTS = {
  DEFAULT: '',
  COMPLETED: 'completed',
};
